import type Vue from 'vue'

import { useSweetAlert } from '@/common/composables/sweet-alert'
import type { ResponseErrorHandler } from '@/common/lib/error-handlers/error-handler'

/**
 * Handle HTTP 403 error
 */
const handleForbidden: ResponseErrorHandler = async (vue: Vue, response: Response): Promise<void> => {
    const { showToast } = useSweetAlert()

    let title: string = vue.$t('errors.403') as string

    try {
        const json = await response.json()

        if (json.errors instanceof Array) {
            title = json.errors.join('\n')
        }
    } catch (e) {
        // JSON is invalid, do nothing.
    }

    await showToast(title, 'error')
}

export { handleForbidden }
